import { ButtonQrType } from '../../../components/ButtonQrType'
import { TFilterOption } from './FiltersSheetTypes'

export type TChipsFilterProps = {
	title: string
	options: TFilterOption[]
	selectedValues?: string[]
	onChange: (value: string) => void
}

export const ChipsFilter = ({
	title,
	options,
	selectedValues,
	onChange,
}: TChipsFilterProps) => {
	const selected = selectedValues || []
	return (
		<div>
			<div className="mb-4 flex items-center gap-2">
				<h3 className="type-body-medium font-semibold text-dark-grey">
					{title}
				</h3>
				{selected.length > 0 && (
					<div className="type-10 flex h-4 w-4 items-center justify-center rounded-full bg-blue p-0.5 leading-[0.625rem] text-white">
						{selected.length}
					</div>
				)}
			</div>
			<div className="flex flex-wrap gap-2">
				{options.map((option) => {
					const isActive = selected.includes(option.value)
					return (
						<ButtonQrType
							key={`${option.value}-${isActive}`}
							title={option.label}
							isActive={isActive}
							onClick={() => onChange(option.value)}
							visual="outlined"
							size="default"
							className="px-4 py-2 shadow-none hover:shadow-none"
						/>
					)
				})}
			</div>
		</div>
	)
}
